import { render, staticRenderFns } from "./EmailBodyPopUp.vue?vue&type=template&id=0cfda296"
import script from "./EmailBodyPopUp.vue?vue&type=script&lang=js"
export * from "./EmailBodyPopUp.vue?vue&type=script&lang=js"
import style0 from "./EmailBodyPopUp.vue?vue&type=style&index=0&id=0cfda296&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports